import firebase from "firebase/compat/app";
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import 'firebase/compat/database'

const firebaseConfig = {
    apiKey: "AIzaSyAX0FWbP7-EaK40Del2L_NkMZmyfuF7VGU",
    authDomain: "childrendocdev.firebaseapp.com",
    projectId: "childrendocdev",
    storageBucket: "childrendocdev.appspot.com",
    messagingSenderId: "719399037789",
    appId: "1:719399037789:web:c86e5510bd0182a8ff96b4"
  };
  
  // Initialize Firebase
  //const app = 
  firebase.initializeApp(firebaseConfig);

  firebase.firestore().settings({timestampsInSnapshots: true})

  export default firebase;